.sectionHeader {
  font-size: 15px;
}

.sectionHeader__link {
  font-size: 15px;
}

@media all and (--reefer-media-tablet-min) {
  .sectionHeader {
    font-size: 20px;
  }
}
